import Vue from 'vue'
import store from '@store'


Vue.prototype.$trans = function(payload, lang = null, fallback = '') {
    var multilingual = store.state.lang

    return multilingual.active
    ? _.get(payload, lang ? lang : multilingual.lang, fallback)
    : payload
}

Vue.prototype.$hasLang = function() {
    return this.lang 
    || (this.field ? true : false) 
    || (_.has(this.value, 'fr') ? true : false)
}